import { render, staticRenderFns } from "./airplane_wind_chart.vue?vue&type=template&id=bf10e072&scoped=true&"
import script from "./airplane_wind_chart.vue?vue&type=script&lang=js&"
export * from "./airplane_wind_chart.vue?vue&type=script&lang=js&"
import style0 from "./airplane_wind_chart.vue?vue&type=style&index=0&id=bf10e072&lang=scss&scoped=true&"
import style1 from "./airplane_wind_chart.vue?vue&type=style&index=1&id=bf10e072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf10e072",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VCard,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bf10e072', component.options)
    } else {
      api.reload('bf10e072', component.options)
    }
    module.hot.accept("./airplane_wind_chart.vue?vue&type=template&id=bf10e072&scoped=true&", function () {
      api.rerender('bf10e072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/chart/airplane_wind_chart.vue"
export default component.exports